


































































































import {Component, Vue, Mixins} from "vue-property-decorator";
import ConfigMixin from "../mixins/ConfigMixin";
import { Invoice, InvoiceService, Quote, QuoteService } from "../services/accounting.service";

    @Component({
        components: {
            
        }
    })
    export default class QuoteView extends Mixins(ConfigMixin) {

        private quote: Quote | null = null;
        private error: string | null = null;
        private loading: boolean = true;

        private paymentAmount: number = 0;
        private paymentCardId: string = "";

        private async created() {
            const quotes = new QuoteService();
            const res = await quotes.getOne(this.$route.params.id);
            console.log(res);
            if (res.success) {
                this.quote = res.result;
                document.title = `Quote #${this.quote.quoteId}`;
            } else {
                this.$router.replace({name: 'PageNotFound'});
            }

            this.loading = false;
        }

        private getName(): string {
            return this.getConfig('NAME');
        }

        private get nameStart(): string {
            const raw = this.getName();
            const parts = raw.split(' ');
            return parts.slice(0, parts.length - 1).join(' ');
        }

        private get nameEnd(): string {
            const raw = this.getName();
            const parts = raw.split(' ');
            return parts[parts.length - 1];
        }

        private get totalAmount(): number {
            if (!this.quote) return 0;

            let sum = 0;

            for (const item of this.quote.items) {
                sum += item.quantity * item.rate;
            }

            return sum;
        }
    }
